<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><a href="#/c002">Claiming the Crown (Hidden Falls High Series, #3)</a></p>
<p><a href="#/c003">Dante Black</a></p>
<p><a href="#/c004">Summer</a></p>
<p><span href="#/c005" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Summer</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Summer</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Summer</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c012" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Summer</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Summer</span></p>
<p><span href="#/c016" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Nat</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Dante</span></p>
<p><span href="#/c019" title="Link target outside of Sample">A Note from Kailin Gow</span></p>
<p><span href="#/c020" title="Link target outside of Sample">NEWS</span></p>
<p><span href="#/c021" title="Link target outside of Sample">https://dl.bookfunnel.com/tjtn7bbb5y</span></p>
<p><span href="#/c022" title="Link target outside of Sample">OTHER RH or STEAMY ROMANCE from | Kailin Gow and Romance On the Go Books</span></p>
<p><span href="#/c023" title="Link target outside of Sample">Magical World</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?121408e5